import React from 'react'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'

// A form docked beside the page instead of over it, so whatever's on screen
// stays readable and copyable while it's filled in. Unlike Modal there's no
// overlay, focus trap or Escape to close: only the close button discards it.
const DockedPanel = ({ title, subtitle, footer, onClose, children }) => (
  <aside className="flex w-[28rem] shrink-0 flex-col border-l border-border bg-background">
    <div className="grid shrink-0 gap-2 border-b border-border px-6 py-4">
      <div className="flex items-center justify-between gap-4">
        <h2 className="font-heading text-base leading-none font-medium">{title}</h2>
        {/* Negative margin keeps the button from pushing the subtitle down */}
        <Button variant="ghost" size="icon-sm" title="Close" className="-my-2" onClick={onClose}>
          <X/>
        </Button>
      </div>
      {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
    </div>
    <div className="min-h-0 flex-1 overflow-y-auto">
      {children}
    </div>
    {footer ? (
      <div className="flex shrink-0 justify-end border-t border-border px-6 py-4">
        {footer}
      </div>
    ) : null}
  </aside>
)

export default DockedPanel
